
import { Upload } from "lucide-react";

interface ProfilePhotoDisplayProps {
  imageUrl: string | null;
}

export const ProfilePhotoDisplay = ({ imageUrl }: ProfilePhotoDisplayProps) => {
  return (
    <div className="relative w-24 h-24">
      {imageUrl ? (
        <div className="w-24 h-24 rounded-full overflow-hidden">
          <img
            src={imageUrl}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        </div>
      ) : (
        <div className="w-24 h-24 rounded-full bg-muted flex items-center justify-center">
          <Upload className="h-8 w-8 text-muted-foreground" />
        </div>
      )}
    </div>
  );
};
